import React from 'react';
import './styles.less';

interface DescriptionProps {
  logo: string;
}

const prefixCls = 'shared-login-left';

const Description: React.FC<DescriptionProps> = ({ logo }) => {
  return (
    <div className={`login-left ${prefixCls}`}>
      <div className="login-brand">
        <div className="brand-logo">
          <img src={logo} alt="橙子8设计" className="logo-image" />
        </div>
        <h1 className="brand-title">橙子8设计</h1>
        <p className="brand-subtitle">专业的在线设计平台</p>
      </div>
      <div className="login-features">
        <div className="feature-item">
          <div className="feature-icon">🎨</div>
          <div className="feature-text">
            <h3>专业设计工具</h3>
            <p>丰富的设计元素和模板库</p>
          </div>
        </div>
        <div className="feature-item">
          <div className="feature-icon">⚡</div>
          <div className="feature-text">
            <h3>高效创作</h3>
            <p>快速生成精美的设计作品</p>
          </div>
        </div>
        <div className="feature-item">
          <div className="feature-icon">☁️</div>
          <div className="feature-text">
            <h3>云端同步</h3>
            <p>随时随地访问您的设计项目</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Description;
